<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-last`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 6.003v35.994c0 1.648-1.882 2.588-3.2 1.6L12.8 25.6a2 2 0 010-3.2l24-17.996c1.319-.99 3.2-.049 3.2 1.6zm-29-2a1 1 0 011 1v37.993a1 1 0 01-1 1H9a1 1 0 01-1-1V5.004a1 1 0 011-1h2zm25 6L17.333 24 36 37.998V10.003z"/></svg>
</template>
<script>

export default {
  name: 'IconLast',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
